"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _lodash = _interopRequireDefault(require("lodash"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _reactVirtualized = require("react-virtualized");
var _material = require("@mui/material");
var _styles = require("@mui/material/styles");
var _windowUtil = _interopRequireDefault(require("../../../logics/windowUtil"));
var _ScrollerTable = _interopRequireDefault(require("./ScrollerTable"));
const _excluded = ["columns", "rowData", "createRow", "rowClassName", "paging", "lastRowClassName", "height", "autoWidth", "responsiveDisp", "fontsize", "isNewWindow", "actionWidth", "putTypography", "reload", "changeViewNum", "showAll", "showAllLabel", "changeShowAll", "useMaxHeight"],
  _excluded2 = ["className", "dataKey", "onClick"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const OUTER_GAP = 16;
const HEADER_HEIGHT_DEFAULT = 56;
const ROW_HEIGHT_DEFAULT = 40;
const ACTION_WIDTH_DEFAULT = 64;
const ACTION_CELL_PADDING = 8;
const StyledPaper = (0, _styles.styled)(_material.Paper)(_ref => {
  let {
    theme
  } = _ref;
  return {
    overflow: 'hidden',
    marginTop: theme.spacing(1),
    boxShadow: 'unset',
    width: '100%',
    '& .rv-table': {
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.fontSize,
      overflowX: 'auto'
    },
    '& .rv-flex': {
      display: 'flex',
      alignItems: 'center',
      boxSizing: 'border-box',
      textAlign: 'left'
    },
    '& .rv-header-cell': {
      paddingLeft: theme.spacing(1),
      fontSize: theme.typography.fontSize
    },
    '& .rv-header-cell:last-child': {
      paddingRight: 0
    },
    '& .rv-row': {
      minHeight: theme.spacing(5),
      borderBottom: '1px solid rgba(224,224,224,1)'
    },
    '& .rv-cell': {
      paddingLeft: theme.spacing(1),
      paddingRight: 0,
      fontSize: theme.typography.fontSize
    },
    '& .rv-row-even': {
      background: theme.palette.table.body.secondary.main
    },
    '& .rv-tbh1': {
      backgroundColor: theme.palette.table.header.primary.main,
      color: theme.palette.table.header.primary.contrastText,
      borderColor: theme.palette.table.header.primary.main,
      width: '100%'
    }
  };
});
const COLUMN_DATAKEY_ACTIONS = 'actions';

/**
 * 一覧表示部品
 * @prop {array} columns - カラム情報
 * @prop {node} columns.label - ヘッダ表示部品
 * @prop {string} columns.dataKey - データキー
 * @prop {number} columns.width - 列の幅（flexGrow>0の場合は、全体の割合）
 * @prop {number} [columns.flexGrow] - 列の幅を全体の割合で指定する（>0であれば有効）
 * @prop {number} [columns.minWidth] - 列の最小幅
 * @prop {number} [columns.maxWidth] - 列の最大幅
 * @prop {object} [columns.headerStyle] - ヘッダのスタイル
 * @prop {object} [columns.cellStyle] - セルのスタイル
 * @prop {array} rowData - 一覧のデータの配列
 * @prop {func} createRow - 一覧のデータからデータキーを属性名とするコンポーネントオブジェクトを作成する<br/>
 *  シグネチャ:(rowData[index]:object): object{[データキー]:コンポーネント,...}
 * @prop {number} [headerHeight] - ヘッダの高さ
 * @prop {number} [rowHeight] - 行の高さ
 * @prop {string} [rowClassName] - 行のクラス名
 * @prop {number} [height] - 高さ
 * @prop {number} [scrollTop] - スクロール数
 * @prop {func}   [onScroll] - スクロール時のイベント <br/>
 *　シグネチャ:({ clientHeight: number, scrollHeight: number, scrollTop: number }): void
 * @prop {String} [lastRowClassName] - 最終行のクラス名
 * @prop {bool} responsiveDisp - responsiveDisp
 * @prop {bool} useMaxheight - テーブルの高さをmaxheightで指定する（responsiveDispがtrueの場合に有効）
 */
class ListTable extends _react.default.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "cache", new _reactVirtualized.CellMeasurerCache({
      fixedWidth: true,
      minHeight: 40
    }));
    _defineProperty(this, "rows", []);
    _defineProperty(this, "isChangeRows", false);
    _defineProperty(this, "lastRenderedWidth", 40);
    _defineProperty(this, "lastFontsize", 0);
    _defineProperty(this, "handleChangePage", (page, pure) => {
      this.props.changeCurrentPage(page);
      if (!pure) {
        _windowUtil.default.scrollAboveElement(this.area, this.props.isNewWindow);
      }
    });
    _defineProperty(this, "handleChangeShow", showAll => {
      this.props.changeShowAll(showAll);
      _windowUtil.default.scrollAboveElement(this.area);
    });
    _defineProperty(this, "handleChangeScrollerTable", (page, pure) => {
      this.props.changeCurrentPage(page);
      if (!pure) {
        _windowUtil.default.scrollAboveElement(this.area, this.props.isNewWindow);
        _windowUtil.default.elementScrollTop(this.area);
      }
    });
    _defineProperty(this, "updateRows", () => {
      setTimeout(() => {
        this.cache.clearAll();
        this.forceUpdate();
      }, 10);
    });
    _defineProperty(this, "headerRenderer", _ref2 => {
      let {
        label,
        columnData
      } = _ref2;
      return /*#__PURE__*/_react.default.createElement(_material.TableCell, {
        component: "div",
        className: (0, _classnames.default)('rv-flex', 'rv-header-cell', 'rv-tbh1'),
        variant: "head",
        style: {
          height: this.props.headerHeight
        }
      }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
        component: "div",
        color: "inherit",
        variant: "body2",
        style: _objectSpread({
          width: columnData.flexGrow ? '100%' : columnData.width,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          display: 'flex',
          alignItems: 'center'
        }, columnData.headerStyle)
      }, label));
    });
    _defineProperty(this, "cellRenderer", _ref3 => {
      let {
        cellData,
        key,
        parent,
        rowIndex,
        columnIndex = null,
        columnData
      } = _ref3;
      return /*#__PURE__*/_react.default.createElement(_reactVirtualized.CellMeasurer, {
        cache: this.cache,
        columnIndex: columnIndex,
        key: key,
        parent: parent,
        rowIndex: rowIndex
      }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
        component: "div",
        className: "rv-cell",
        variant: "body2",
        style: _objectSpread({
          width: columnData.flexGrow ? '100%' : columnData.width
        }, columnData.cellStyle)
      }, cellData));
    });
    _defineProperty(this, "renderTable", (width, rows) => {
      const _this$props = this.props,
        {
          columns,
          rowData,
          createRow,
          rowClassName,
          paging,
          lastRowClassName,
          height,
          autoWidth,
          responsiveDisp,
          fontsize,
          isNewWindow,
          actionWidth,
          putTypography,
          reload,
          changeViewNum,
          showAll,
          showAllLabel,
          changeShowAll,
          useMaxHeight
        } = _this$props,
        tableProps = _objectWithoutProperties(_this$props, _excluded);
      if (this.lastRenderedWidth !== width || this.lastFontsize !== fontsize || this.isChangeRows) {
        this.lastRenderedWidth = width;
        this.lastFontsize = fontsize;
        this.updateRows();
      }
      if (responsiveDisp) {
        let _width = 0;
        let _actionWidth = 0;
        if (!actionWidth) {
          _actionWidth = ACTION_WIDTH_DEFAULT;
        }
        columns.forEach(item => {
          if (item.dataKey === COLUMN_DATAKEY_ACTIONS) {
            if (item.direction === 'row') {
              _width += item.label.length * _actionWidth + ACTION_CELL_PADDING * 2;
            } else {
              _width += _actionWidth + ACTION_CELL_PADDING * 2;
            }
          } else {
            _width += item.width;
          }
        });
        return /*#__PURE__*/_react.default.createElement("div", {
          ref: ref => this.area = ref,
          style: {
            overflow: 'auto'
          }
        }, rowData.length !== 0 && /*#__PURE__*/_react.default.createElement("div", {
          style: {
            height: useMaxHeight ? undefined : height - OUTER_GAP,
            maxHeight: useMaxHeight ? height - OUTER_GAP : undefined
          }
        }, /*#__PURE__*/_react.default.createElement(_ScrollerTable.default, {
          columns: columns,
          rowData: rowData,
          createRow: createRow,
          tableWidth: _width,
          headerHeight: 0,
          putTypography: putTypography,
          reload: reload,
          striped: true,
          columnPadding: true,
          actionWidth: actionWidth,
          lastRowClassName: lastRowClassName
        })));
      } else {
        return /*#__PURE__*/_react.default.createElement(_reactVirtualized.Table, _extends({
          deferredMeasurementCache: this.cache
        }, tableProps, {
          className: autoWidth ? '' : 'rv-table',
          height: height - OUTER_GAP,
          width: width,
          rowHeight: this.cache.rowHeight,
          rowCount: rows.length,
          rowGetter: _ref4 => {
            let {
              index
            } = _ref4;
            return rows[index];
          },
          rowClassName: _ref5 => {
            let {
              index
            } = _ref5;
            return (0, _classnames.default)('rv-row', 'rv-flex', rowClassName, index % 2 ? 'rv-row-even' : undefined, lastRowClassName && index === rows.length - 1 ? lastRowClassName : undefined);
          }
        }), columns.map((_ref6, index) => {
          let {
              className,
              dataKey,
              onClick
            } = _ref6,
            other = _objectWithoutProperties(_ref6, _excluded2);
          return /*#__PURE__*/_react.default.createElement(_reactVirtualized.Column, _extends({
            key: dataKey,
            headerRenderer: headerProps => {
              return this.headerRenderer(_objectSpread(_objectSpread({}, headerProps), {}, {
                columnIndex: index
              }));
            },
            headerClassName: "rv-tbh1",
            className: (0, _classnames.default)('rv-flex', className),
            cellRenderer: this.cellRenderer,
            columnData: other,
            dataKey: dataKey
          }, other));
        }));
      }
    });
  }
  componentDidMount() {
    this.updateRows();
    this.lastFontsize = this.props.fontsize;
  }
  componentDidUpdate(props) {
    if (this.isChangeRows || this.props.rowData.length !== props.rowData.length || !_lodash.default.isEqual(this.props.rowData, props.rowData)) {
      this.updateRows();
      this.isChangeRows = false;
    }
  }
  render() {
    const {
      columns,
      height,
      className,
      rowData,
      createRow,
      autoWidth,
      responsiveDisp,
      useMaxHeight
    } = this.props;
    const rows = rowData.map((data, index) => {
      return createRow(data, index);
    });

    // 前回描画時の要素と今回描画する要素を比較する。
    // 違った場合再描画フラグをオン
    if (this.rows.length === rows.length) {
      for (let i = 0; i < rows.length; i++) {
        if (Object.keys(rows[i]).some(key => {
          // dom要素で子要素がある場合子要素を比較
          if (rows[i][key] && typeof rows[i][key] === 'object' && rows[i][key].props.children) {
            if (rows[i][key].props.children.length === this.rows[i][key].props.children.length) {
              for (let j = 0; j < rows[i][key].props.children.length; j++) {
                if (String(rows[i][key].props.children[j]) !== String(this.rows[i][key].props.children[j])) {
                  return true;
                }
              }
            } else {
              return true;
            }
          }
          return String(rows[i][key]) !== String(this.rows[i][key]);
        })) {
          this.rows = [...rows];
          this.isChangeRows = true;
        }
      }
    } else {
      this.rows = [...rows];
      this.isChangeRows = true;
    }
    let totalWidth = 0;
    columns.forEach(headerInfo => {
      totalWidth += headerInfo.width;
    });
    return /*#__PURE__*/_react.default.createElement(StyledPaper, {
      style: {
        height: useMaxHeight ? undefined : height - OUTER_GAP,
        maxHeight: useMaxHeight ? height - OUTER_GAP : undefined
      },
      className: (0, _classnames.default)(className)
    }, autoWidth && !responsiveDisp ? /*#__PURE__*/_react.default.createElement(_reactVirtualized.AutoSizer, {
      disableHeight: true
    }, _ref7 => {
      let {
        width
      } = _ref7;
      return this.renderTable(width, rows);
    }) : this.renderTable(totalWidth, rows));
  }
}
ListTable.propTypes = {
  columns: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.node.isRequired,
    dataKey: _propTypes.default.string.isRequired,
    width: _propTypes.default.number.isRequired,
    flexGrow: _propTypes.default.number,
    align: _propTypes.default.string,
    className: _propTypes.default.string
  })).isRequired,
  rowData: _propTypes.default.array.isRequired,
  createRow: _propTypes.default.func.isRequired,
  headerHeight: _propTypes.default.number,
  rowClassName: _propTypes.default.string,
  rowHeight: _propTypes.default.number,
  height: _propTypes.default.number,
  scrollTop: _propTypes.default.number,
  onScroll: _propTypes.default.func,
  lastRowClassName: _propTypes.default.string,
  responsiveDisp: _propTypes.default.bool,
  useMaxHeight: _propTypes.default.bool
};
ListTable.defaultProps = {
  headerHeight: HEADER_HEIGHT_DEFAULT,
  rowHeight: ROW_HEIGHT_DEFAULT,
  height: 350
};
const mapStateToProps = state => {
  return {
    fontsize: state.coreFont.fontsize
  };
};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps)(ListTable);